import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import notifier from '../../../_utils/notifier';
import { checkFavoriteOffer, deleteFavoriteOffers, addToCartFavoriteOffers,
  buyFavoriteOffer } from '../../actions/favorites';
import BuyOneClickButton from '../common/ShopOfferItem/BuyOneClickButton.jsx';
import BuyOneClickButtonModal from '../common/ShopOfferItem/BuyOneClickButtonModal.jsx';
import DeleteButton from '../common/Buttons/DeleteButton.jsx';
import ShopOfferItem from '../common/ShopOfferItem/ShopOfferItem.jsx';
import Picture from '../common/ShopOfferItem/Picture.jsx';


class FavoritesItem extends React.Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    discount: PropTypes.number.isRequired,
  };

  handleCheckClick = () => {
    this.props.checkFavoriteOffer(this.props.id);
  };

  handleBuyClick = async (coupon='') => {
    const response = await this.props.buyFavoriteOffer(this.props.id, { 'coupon': coupon })
    if (response && response.error) notifier.alert(response.error);
  };

  handleCartClick = async (event) => {
    event.currentTarget.setAttribute('disabled', 'disabled');
    let response = await this.props.addToCartFavoriteOffers([this.props.id]);
    if (response) notifier.success(gettext('Аранжировка успешно добавлена в корзину'));
  };

  handleDeleteClick = () => {
    this.props.deleteFavoriteOffers([this.props.id]);
  };

  render() {
    const imageBlock = <>
      <Picture image={ this.props.thumbnail } title={ this.props.name } />
        { this.props.discount > 0 && <div class='corner-ribbon corner-ribbon_size_big'>
          <span class='corner-ribbon__text corner-ribbon__text_size_big'>{ this.props.discount }%</span>
        </div> }
    </>

    const checkboxBlock = <input type="checkbox"
                                 name='offer[]'
                                 value={ this.props.id }
                                 checked={ this.props.is_checked }
                                 onChange={ this.handleCheckClick }/>

    return <ShopOfferItem {...this.props} imageBlock={ imageBlock } checkboxBlock={ checkboxBlock }>
      <Row className='mb-3'>
        <Col xs={12} md={8}>
          { this.props.is_valid && <>
            { this.props.discount > 0 ? <BuyOneClickButton onClick={ this.handleBuyClick }/>
                                      : <BuyOneClickButtonModal id={ this.props.id }
                                                                title={ this.props.title }
                                                                price={ this.props.price_number }
                                                                shopoffers_type={ this.props.shopoffers_type }
                                                                currency={ this.props.currency }
                                                                onClick={ this.handleBuyClick }/> }
            <Button size="sm" variant='outline-dark' title={ gettext('Добавить в корзину') }
                    onClick={ this.handleCartClick }>
              <span className="icon icon-cart-arrow-down"></span> { gettext('В корзину') }
            </Button>
          </> }
        </Col>
        <Col xs={12} md={4} className='text-md-right mt-2 mt-md-0'>
          <DeleteButton title={ gettext('Удалить из избранного') } text={ gettext('Удалить') } onDeleteClick={ this.handleDeleteClick }/>
        </Col>
      </Row>
    </ShopOfferItem>
  }
};

export default compose(
  connect(null,
    {
      checkFavoriteOffer, deleteFavoriteOffers, addToCartFavoriteOffers, buyFavoriteOffer,
    }),
)(FavoritesItem);

